import { render, staticRenderFns } from "./AdminSystemSettings.vue?vue&type=template&id=1c61ba54&scoped=true"
import script from "./AdminSystemSettings.vue?vue&type=script&lang=js"
export * from "./AdminSystemSettings.vue?vue&type=script&lang=js"
import style0 from "./AdminSystemSettings.vue?vue&type=style&index=0&id=1c61ba54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c61ba54",
  null
  
)

export default component.exports